var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 20.5C13.9766 20.5 11.75 18.2734 11.75 15.5C11.75 12.7266 13.9766 10.5 16.75 10.5C19.5234 10.5 21.75 12.7266 21.75 15.5C21.75 18.2734 19.5234 20.5 16.75 20.5ZM16.75 12.375C15.0312 12.375 13.625 13.7812 13.625 15.5C13.625 17.2188 15.0312 18.625 16.75 18.625C18.4688 18.625 19.875 17.2188 19.875 15.5C19.875 13.7812 18.4688 12.375 16.75 12.375ZM18.7422 22.375C22.4531 22.375 25.5 25.4219 25.5 29.1328C25.5 29.875 24.875 30.5 24.1328 30.5H9.36719C8.625 30.5 8 29.875 8 29.1328C8 25.4219 11.0469 22.375 14.7578 22.375H18.7422ZM9.91406 28.625H23.5859C23.3516 26.1641 21.2422 24.25 18.7422 24.25H14.7578C12.2578 24.25 10.1484 26.1641 9.91406 28.625ZM26.75 23C30.1875 23 33 25.8125 33 29.25C33 29.9531 32.4531 30.5 31.75 30.5H26.3594C26.5938 30.1094 26.75 29.6406 26.75 29.1328C26.75 26.6719 25.6172 24.4844 23.8594 23H26.75ZM24.875 20.5C23.6641 20.5 22.5703 19.9922 21.75 19.2109C22.5312 18.1562 23 16.9062 23 15.5C23 14.4453 22.7266 13.5078 22.2578 12.6094C23 12.1016 23.8984 11.75 24.875 11.75C27.2969 11.75 29.25 13.7031 29.25 16.125C29.25 18.5469 27.2969 20.5 24.875 20.5Z",
    fill: "#0E0E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/Live.9d082b25ae8fbf0566087932668889b2.svg";
export { ForwardRef as ReactComponent };